import { Button, Container, styled, Typography } from "@mui/material"
import { EXTERNAL_UNAUTHORIZED, PLTFRM_UNAUTHORIZED, REQUEST_ACCESS, BACK, PAGE_LOAD_ERR, TRY_AGN_LTR, REACH_OUT, INVALID, INTERNAL_UNAUTHORIZED } from "../constants/navigation";
import samsLogo from '../assets/sams_logo.png';
import './style.css';
// import { navigate } from "../utils/navigation";


interface DenyAccessProps {
    title?: string;
    subtext?: string;
    attemptedUrl?: string;
}
const DenyAccess: React.FC<DenyAccessProps> = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const scope = urlParams.get('scope');
    const attemptedUrl = urlParams.get('path');
    let pageTitle: string;
    let subText: string;

    switch (scope) {
        case 'route':
            pageTitle = EXTERNAL_UNAUTHORIZED;
            subText = REACH_OUT;
            break;
        case 'all':
            pageTitle = PLTFRM_UNAUTHORIZED;
            subText = REQUEST_ACCESS;
            break;
        case 'internal':
            pageTitle = INVALID;
            subText = INTERNAL_UNAUTHORIZED;
            break;
        default:
            pageTitle = PAGE_LOAD_ERR;
            subText = TRY_AGN_LTR;
            break;
    }

    const goBack = () => '' // navigate({ path: '/' })

    const BootstrapButton = styled(Button)({
        textTransform: 'none',
        textDecoration: 'underline'
    })
    return (

        <Container className="container">
            {(scope !== 'internal') && (
                <img
                    src={samsLogo}
                    alt="Sams Logo"
                    className="logo"
                />
            )}
            <Typography variant="h4" component="h1" className="typographyHeading">
                {pageTitle}
            </Typography>
            <Typography variant="body1" className="typographyBody">
                {subText}
            </Typography>
            {(scope === 'internal') && (
                <Typography variant="body1" className="typographyBody">
                    <strong>{attemptedUrl || "Unknown URL"}</strong>
                </Typography>
            )}
            <BootstrapButton variant="text" color="primary" onClick={goBack}>{BACK}</BootstrapButton>
            <Container>
                {(scope === 'internal') && (
                    <img
                        src={samsLogo}
                        alt="Sams Logo"
                        className="logo"
                    />
                )}
            </Container>
        </Container>
    );
};

export default DenyAccess;